import { ls } from 'utils/my-localstorage'
import { find, forEachObjIndexed, propEq } from 'ramda'
import { useSelector } from 'react-redux'
import {
  CHECKBOX_LIST,
  databaseFiltersName,
  DATE_INTERVAL,
  filterTypes,
  INTERVAL,
  MULTISELECT_SWITCHER,
  PRICE_INTERVAL,
  RADIO_LIST,
  RHEOSTAT,
  SCORE,
  SEARCH_USERS,
  SWITCHER,
} from 'utils/consts'
import { useFilterStoreData } from 'utils/hooks/useFilterStoreData'
import type { RootState } from 'store'
import { getDatabaseFiltersCollection } from 'utils/filtersCollections'

export const useDatabaseFiltersInputs = () => {
  const { storeName, filtersStorageName } = useFilterStoreData()

  const filtersFromStorage = ls.getObject(filtersStorageName)

  const filtersFromStore = useSelector(
    (state: RootState) => state?.tableFilters?.[storeName]?.filters
  )

  const getTableFilters = filters => {
    const inputs = [] as any[]
    forEachObjIndexed((value, key) => {
      const filterFromCollection = find(propEq('filterName', key))(
        getDatabaseFiltersCollection()
      )
      switch (filterFromCollection?.type) {
        case filterTypes[CHECKBOX_LIST]:
          if (value.length > 0 && value != -1) {
            inputs.push({
              listInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[SEARCH_USERS]:
          if (value.length > 0) {
            inputs.push({
              freeListInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[DATE_INTERVAL]:
          inputs.push({
            dateRangeInput: {
              key: filterFromCollection?.apiFilterName,
              fromDate: value?.fromDate ?? null,
              toDate: value?.toDate ?? null,
            },
          })
          break
        case filterTypes[RADIO_LIST]:
          inputs.push({
            listInput: {
              key: filterFromCollection?.apiFilterName,
              byName: value,
            },
          })
          break
        case filterTypes[MULTISELECT_SWITCHER]:
          if (
            filterFromCollection?.filterName ==
              databaseFiltersName?.grapesFilter &&
            (value?.list?.length > 0 || value?.switcher)
          ) {
            inputs.push({
              complexInput: {
                key: 'grapeAndMonocepage',
                childrenInputs: [
                  {
                    booleanInput: {
                      key: 'grapeAndMonocepage.monocepage',
                      value: value?.switcher,
                    },
                  },
                  {
                    listInput: {
                      key: 'grapeAndMonocepage.grape',
                      byName: value?.list,
                    },
                  },
                ],
              },
            })
          }
          break
        case filterTypes[RHEOSTAT]:
        case filterTypes[INTERVAL]:
          inputs.push({
            rangeInput: {
              key: filterFromCollection?.apiFilterName,
              ...value,
            },
          })
          break
        case filterTypes[PRICE_INTERVAL]:
          inputs.push({
            complexInput: {
              key: filterFromCollection?.apiFilterName,
              childrenInputs: [
                ...(value?.currency
                  ? [
                      {
                        listInput: {
                          key: `${filterFromCollection?.apiFilterName}.currency`,
                          byName: value?.currency,
                        },
                      },
                    ]
                  : []),
                ...(value?.interval
                  ? [
                      {
                        rangeInput: {
                          key: `${filterFromCollection?.apiFilterName}.value`,
                          minValue: value?.interval?.minValue,
                          maxValue: value?.interval?.maxValue,
                        },
                      },
                    ]
                  : []),
              ],
            },
          })
          break
        case filterTypes[SCORE]:
          if (value != -1) {
            inputs.push({
              listInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break

        case filterTypes[SWITCHER]:
          inputs.push({
            booleanInput: {
              key: filterFromCollection?.apiFilterName,
              value: value,
            },
          })
          break

        default:
          break
      }
    }, filters)
    return inputs.length ? inputs : null
  }

  return { getTableFilters, filtersFromStore, filtersFromStorage }
}
